function initVideoSlider(root) {
  if (!root) return;
  const slider = root.querySelector('.slider-video');
  if (!slider) return;

  const videoItems = [...root.querySelectorAll('.video-item')];
  const totalVideos = videoItems.length;

  const prevBtn = root.querySelector('.shop__video .prev');
  const nextBtn = root.querySelector('.shop__video .next');

  let currentIndex = 0;
  let sectionInViewport = false;

  const getColumns = () =>
    window.innerWidth <= 768 ? 1 : parseInt(slider.getAttribute('data-columns')) || 1;

  const getMaxIndex = () => Math.max(totalVideos - getColumns(), 0);

  const updateNavButtons = () => {
    const maxIndex = getMaxIndex();
    if (prevBtn) prevBtn.classList.toggle('disabled', currentIndex <= 0);
    if (nextBtn) nextBtn.classList.toggle('disabled', currentIndex >= maxIndex);
  };

  const updateSliderPosition = () => {
    const itemWidth = videoItems[0]?.offsetWidth || 0;
    slider.style.transform = `translateX(${-currentIndex * itemWidth}px)`;
    slider.style.transition = 'transform 0.4s ease-in-out';
    updateNavButtons();
  };

  const updateLayout = () => {
    const columns = getColumns();

    if (window.innerWidth <= 768) {
      videoItems.forEach(el => el.style.width = '100%');
    } else if (columns === 4 && totalVideos === 4) {
      videoItems.forEach(el => el.style.width = '25%');
    } else if (columns === 4 && totalVideos === 3) {
      videoItems.forEach(el => {
        el.style.width = '25%';
        el.style.flex = '0 0 auto';
      });
    } else {
      videoItems.forEach(el => el.style.width = `calc(100% / ${columns})`);
    }

    updateSliderPosition();
    updateNavButtons();
  };

  const pauseAllVideos = () => {
    videoItems.forEach(item => {
      const v = item.querySelector('video');
      if (v && !v.paused) v.pause();
      const mutedBtn = item.querySelector('.action_muted');
      if (mutedBtn) mutedBtn.classList.add('hidden');
      item.classList.remove('is-playing');
    });
  };

  const playVideo = (index) => {
    const videoItem = videoItems[index];
    if (!videoItem || !sectionInViewport) return;
    const video = videoItem.querySelector('video');
    if (!video) return;

    videoItems.forEach((item, i) => {
      if (i !== index) {
        const v = item.querySelector('video');
        if (v && !v.paused) v.pause();
        const mutedBtn = item.querySelector('.action_muted');
        if (mutedBtn) mutedBtn.classList.add('hidden');
        item.classList.remove('is-playing');
      }
    });

    if (video.paused) {
      video.play().catch(err => {
        if (err.name !== 'AbortError') console.error(err);
      });
    }

    const mutedBtn = videoItem.querySelector('.action_muted');
    if (mutedBtn) mutedBtn.classList.remove('hidden');
    videoItem.classList.add('is-playing');
  };

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const wasInViewport = sectionInViewport;
      sectionInViewport = entry.isIntersecting;

      if (sectionInViewport && !wasInViewport) {
        playVideo(currentIndex);
      } else if (!sectionInViewport && wasInViewport) {
        pauseAllVideos();
      }
    });
  }, { threshold: 0.1, rootMargin: '100px 0px' });

  sectionObserver.observe(root);

  nextBtn?.addEventListener('click', () => {
    if (currentIndex < getMaxIndex()) {
      currentIndex++;
      updateSliderPosition();
      playVideo(currentIndex);
    }
  });

  prevBtn?.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateSliderPosition();
      playVideo(currentIndex);
    }
  });

  videoItems.forEach((item, i) => {
    const video = item.querySelector('video');
    if (!video) return;

    video.addEventListener('ended', () => {
      if (window.innerWidth <= 768 && currentIndex < totalVideos - 1) {
        currentIndex++;
        updateSliderPosition();
        playVideo(currentIndex);
      }
    });

    const playHandler = () => {
      if (!sectionInViewport) return;
      playVideo(i);
    };

    video.addEventListener('mouseenter', playHandler);
    video.addEventListener('touchstart', playHandler, { passive: true });
    video.addEventListener('focusin', playHandler);
  });

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('.action_muted');
    if (!btn) return;

    const video = btn.closest('.video_load')?.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    btn.classList.toggle('muted');
    btn.classList.toggle('unmuted');
  });

  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const btn = e.target.closest('.action_muted');
    if (!btn) return;

    e.preventDefault();
    btn.click();
  });

  // Swipe support with real-time tracking
  let touchStartX = 0;
  let touchStartY = 0;
  let isTouchingSlider = false;
  let isDragging = false;
  let dragOffset = 0;
  let baseTranslateX = 0;
  let directionLocked = false;
  let isHorizontal = false;

  slider.addEventListener('touchstart', e => {
    if (e.target.closest('.video-products-slider.has-multiple')) {
      isTouchingSlider = false;
      return;
    }
    isTouchingSlider = slider.contains(e.target);
    if (!isTouchingSlider) return;

    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isDragging = false;
    dragOffset = 0;
    directionLocked = false;
    isHorizontal = false;

    const itemWidth = videoItems[0]?.offsetWidth || 0;
    baseTranslateX = -currentIndex * itemWidth;
    slider.style.transition = 'none';
  }, { passive: true });

  slider.addEventListener('touchmove', e => {
    if (!isTouchingSlider) return;

    const dx = e.touches[0].clientX - touchStartX;
    const dy = e.touches[0].clientY - touchStartY;

    if (!directionLocked && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
      directionLocked = true;
      isHorizontal = Math.abs(dx) > Math.abs(dy);
    }

    if (!directionLocked || !isHorizontal) return;

    isDragging = true;
    dragOffset = dx;

    var maxIndex = getMaxIndex();
    if ((currentIndex <= 0 && dx > 0) || (currentIndex >= maxIndex && dx < 0)) {
      dragOffset = dx * 0.3;
    }

    slider.style.transform = 'translateX(' + (baseTranslateX + dragOffset) + 'px)';
  }, { passive: true });

  slider.addEventListener('touchend', e => {
    if (!isTouchingSlider) return;
    isTouchingSlider = false;

    if (!isDragging) return;

    var threshold = 40;
    var velocity = Math.abs(dragOffset);

    if (velocity > threshold && isHorizontal) {
      if (dragOffset < 0 && currentIndex < getMaxIndex()) {
        currentIndex++;
      } else if (dragOffset > 0 && currentIndex > 0) {
        currentIndex--;
      }
    }

    isDragging = false;
    dragOffset = 0;
    updateSliderPosition();
    playVideo(currentIndex);
  }, { passive: true });

  let resizeTimer;
  let lastIsWide = window.innerWidth > 750;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const isWide = window.innerWidth > 750;
      if (isWide !== lastIsWide) {
        updateLayout();
        lastIsWide = isWide;
      }
    }, 200);
  }, { passive: true });

  updateLayout();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.section-shoppable-video').forEach(section => {
    initVideoSlider(section);
  });
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    const section = document.getElementById(`shopify-section-${e.detail.sectionId}`);
    if (section) initVideoSlider(section);
  });
}